import React from "react";
import { SingleWFHLeaveApplyDataType } from "../../redux/stcoTools/stcoToolsType";
import { CircularAvatar } from "../commons";
import { ApplyLeaveDate } from "../../commonTypes/stcoToolsType";
import { Pdf } from "../../assets/images";
import { useLocation } from "react-router-dom";

type AppProps = {
  singleData: SingleWFHLeaveApplyDataType;
};
const ViewSingleWFHAndLeaveDeatilsData = ({ singleData }: AppProps) => {
  const { pathname } = useLocation();
  const isWFH = pathname === "/my-space/pending-wfh" || singleData?.type === 2;
  const data = singleData;
  const casualLeaveData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return el?.leave_type === "Casual Leave";
      })
    : [];
  const WFHData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return el?.leave_type === "WFH";
      })
    : [];
  const unpaidLeaveData = data?.details?.length
    ? data?.details?.filter((el: ApplyLeaveDate, index: number) => {
        return (
          el?.leave_type === "Unpaid Leave" ||
          el?.leave_type === "Unpaid Leave(full time)"
        );
      })
    : [];
  let createdName = `${
    data?.user_details?.first_name ? data?.user_details?.first_name : ""
  } ${data?.user_details?.first_name ? data?.user_details?.last_name : ""}`;
  const previewData = (file: any) => {
    let fileNameSplited = file?.file_name?.split(".");
    const finalFileName =
      file?.file_name?.length > 16
        ? `${file?.file_name.slice(0, 16)}...${
            fileNameSplited[fileNameSplited?.length - 1]
          }`
        : file?.file_name;
    let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
    let blobToken = process.env.REACT_APP_BLOB_TOEKN;
    return (
      <a
        href={`${blobBaseUrl}${file?.file_url}?${blobToken}`}
        target="_blank"
        className="uploaded_file_name"
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "#e1e1e3",
            borderRadius: "0px",
            overflow: "hidden",
            padding: "10px",
            width: "120px",
            height: "60px",
            cursor: "pointer",
          }}
        >
          <img
            src={
              file?.file_type?.toLowerCase() === "image/png" ||
              file?.file_type?.toLowerCase() === "image/jpeg" ||
              file?.file_type?.toLowerCase() === "image/jpg"
                ? blobBaseUrl + file?.file_url + "?" + blobToken
                : Pdf
            }
            alt={`leave_${finalFileName}`}
            width={file?.file_type === "application/pdf" ? "40px" : `100%`}
            height="100%"
            loading="lazy"
          />
        </div>
      </a>
    );
  };
  return (
    <>
      <div className=" d-flex align-items-center mt-3">
        <div style={{ fontSize: "14px", color: "#6e7491" }}>Applied By </div>
        <div className="ml-2">
          <CircularAvatar
            name={createdName}
            image={
              data?.user_details?.profile_pic &&
              data?.user_details.profile_pic?.file_url
            }
          />
        </div>
        <div className="ml-2" style={{ fontSize: "15px", fontWeight: 600 }}>
          {createdName}
        </div>
      </div>
      <div className=" d-flex mt-3" style={{ gap: "5%" }}>
        <div style={{ width: "20%" }}>
          <div className="mb-2" style={{ color: "#6e7491" }}>
            {isWFH ? "Start" : "Leave"} From
          </div>
          <div>{data?.start_date}</div>
        </div>
        <div style={{ width: "14%" }}>
          <div className="mb-2" style={{ color: "#6e7491" }}>
            {isWFH ? "End" : "Leave"} To
          </div>
          <div>{data?.end_date}</div>
        </div>
      </div>

      <div className="d-flex mt-3" style={{ gap: "5%" }}>
        <div style={{ width: "20%" }}>
          <div className="mb-2" style={{ color: "#6e7491" }}>
            Applying {isWFH ? "WFH" : "Leave"} For
          </div>
          <div className="manufacturing-journal ">{data?.total_days} Days</div>
        </div>
        <div style={{ width: "60%" }}>
          {data?.people_to_notify?.length ? (
            <>
              <div className="mb-2" style={{ color: "#6e7491" }}>
                People To Notify
              </div>
              <div className="d-flex " style={{ gap: "1%", flexWrap: "wrap" }}>
                {data?.people_to_notify?.map((el: any) => {
                  let name = `${el?.first_name ? el?.first_name : ""} ${
                    el?.last_name ? el?.last_name : ""
                  }`;
                  return (
                    <div
                      className="d-flex mb-2"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <div className="ml-2">
                        <CircularAvatar
                          name={name}
                          image={el?.profile_pic && el.profile_pic?.file_url}
                        />
                      </div>
                      <div className="ml-2" style={{ fontWeight: 500 }}>
                        {name}
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            ""
          )}
        </div>
      </div>

      <div
        className="row col-md-12 mb-3 mt-4"
        style={{ fontSize: "17px", fontWeight: 500 }}
      >
        {isWFH ? "Work From Home" : "Leave"} Details
      </div>
      {isWFH && WFHData?.length ? (
        <div>
          {/* <div
            style={{ fontSize: "15px", fontWeight: 500 }}
            className="mb-2 ml-2"
          >
            WFH
          </div> */}
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {WFHData?.length
              ? WFHData?.map((el: ApplyLeaveDate, index: number) => {
                  return (
                    <>
                      <div
                        className="mb-3 ml-2 apply-date-range-container"
                        style={{ width: "30%", justifyContent: "space-evenly" }}
                      >
                        <div style={{ fontWeight: 500 }}>{el?.date}</div>
                        <div>{el?.duration_type}</div>
                      </div>
                    </>
                  );
                })
              : ""}
          </div>
        </div>
      ) : (
        ""
      )}
      {!isWFH && casualLeaveData?.length ? (
        <div>
          <div
            style={{ fontSize: "15px", fontWeight: 500 }}
            className="mb-2 ml-2"
          >
            Casual
          </div>
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {casualLeaveData?.length
              ? casualLeaveData?.map((el: ApplyLeaveDate, index: number) => {
                  return (
                    <>
                      <div
                        className="mb-3 ml-2 apply-date-range-container"
                        style={{ width: "30%", justifyContent: "space-evenly" }}
                      >
                        <div style={{ fontWeight: 500 }}>{el?.date}</div>
                        <div>{el?.duration_type}</div>
                      </div>
                    </>
                  );
                })
              : ""}
          </div>
        </div>
      ) : (
        ""
      )}
      {!isWFH && unpaidLeaveData?.length ? (
        <div>
          <div
            style={{ fontSize: "15px", fontWeight: 500 }}
            className="mb-2 ml-2"
          >
            Unpaid
          </div>
          <div className="d-flex" style={{ flexWrap: "wrap" }}>
            {unpaidLeaveData?.length
              ? unpaidLeaveData?.map((el: ApplyLeaveDate, index: number) => {
                  return (
                    <>
                      <div
                        className="mb-3 ml-2 apply-date-range-container"
                        style={{ width: "30%", justifyContent: "space-evenly" }}
                      >
                        <div style={{ fontWeight: 500 }}>{el?.date}</div>
                        <div>{el?.duration_type}</div>
                      </div>
                    </>
                  );
                })
              : ""}
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="mt-3 mb-2" style={{ color: "#6e7491" }}>
        Reason
      </div>
      <div className="p-3 m-0">{data?.reason}</div>
      {data?.file_attachment?.length > 0 ? (
        <div style={{ color: "#6e7491" }} className="mt-4">
          Attached File
        </div>
      ) : (
        ""
      )}
      <div className="d-flex mt-3" style={{ gap: "3%" }}>
        {data?.file_attachment?.length > 0
          ? data?.file_attachment?.map((file: any, index: any) => {
              return <div>{previewData(file)}</div>;
            })
          : ""}
      </div>
    </>
  );
};

export default ViewSingleWFHAndLeaveDeatilsData;
